import * as Monaco from 'monaco-editor/esm/vs/editor/editor.api';

import { LANGUAGE_CONFIGURATION } from 'src/containers/MonacoEditor/constants/editor';
import { LanguageId } from 'src/containers/MonacoEditor/constants/languageId';
import { sparqlMonarchTokensProvider } from 'src/containers/MonacoEditor/constants/sparql';
import { srsMonarchTokensProvider } from 'src/containers/MonacoEditor/constants/srs';
import {
  EDITOR_THEME,
  EDITOR_THEME_ID,
} from 'src/containers/MonacoEditor/constants/theme';

export const registerMonacoLanguages = () => {
  const srsId = Monaco.languages.getEncodedLanguageId(LanguageId.SRS);
  if (srsId) {
    return;
  }

  // we also register SPARQL tokens since SRS can have embedded SPARQL
  Monaco.languages.register({ id: LanguageId.SPARQL });
  Monaco.languages.setMonarchTokensProvider(
    LanguageId.SPARQL,
    sparqlMonarchTokensProvider
  );
  Monaco.languages.setLanguageConfiguration(
    LanguageId.SPARQL,
    LANGUAGE_CONFIGURATION
  );

  Monaco.languages.register({ id: LanguageId.SRS });
  Monaco.languages.setMonarchTokensProvider(
    LanguageId.SRS,
    srsMonarchTokensProvider
  );
  Monaco.languages.setLanguageConfiguration(
    LanguageId.SRS,
    LANGUAGE_CONFIGURATION
  );
};

export const setEditorTheme = (editor: Monaco.editor.IStandaloneCodeEditor) => {
  // @ts-ignore
  if (editor?._themeService?._theme === EDITOR_THEME_ID) {
    return;
  }

  Monaco.editor.defineTheme(EDITOR_THEME_ID, EDITOR_THEME);
  Monaco.editor.setTheme(EDITOR_THEME_ID);
};
